export interface DeviceApi {
  hasLocationPermissions(): boolean;
  requestLocationPermissions(): void;
  getAndroidVersion(): number;
  getAppVersion(): string;
  getDeviceId(): string;
  getDeviceModel(): string;
  getDisplayHeight(): number;
  getDisplayWidth(): number;
}

export type Orientation = 'landscape' | 'portrait' | undefined | null;

export interface Device {
  id?: string;
  model?: string;
  orientation?: Orientation;
  rotate?: number;
  latitude: number;
  longitude: number;
  name?: string;
  createdOn?: Date;
  approved?: boolean;
  width: number;
  height: number;
  description?: string;
  network_id: number;
  owner_id: number;
  mediatype_id: number;
  organization?: string;
  footerData?: Record<string, unknown>;
}

export interface DeviceLocation {
  lat?: number;
  lng?: number;
  error?: unknown;
}

export enum AdType {
  // Direct = 'direct',
  Hivestack = 'hivestack',
  Broadsign = 'broadsign',
  Vistar = 'vistar',
  Component = 'component',
  // Custom = 'custom',
  Fallback = 'fallback',
  Server = 'server',
  Weather = 'weather',
  News = 'news',
}

export const AdProviders = [AdType.Hivestack, AdType.Broadsign, AdType.Vistar];
